// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-badge-content {
  background: #5ea1d8;
}

input {
  outline: none !important;
}

label {
  color: #212427 !important;
}

.label-button {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.label-button label {
  margin: 0px;
}

.main-div {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 89vh;
  background: #efeeee !important;
}
.main-div .main-content {
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 20px 20px !important;
  width: 90%;
  max-width: 600px;
  max-height: auto;
  width: 100%;
  position: relative;
  padding: 0px;
  border: 1px solid #ddd;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
  text-align: center;
}
.main-div .mat-form-field-appearance-legacy .mat-form-field-underline {
  background: lightgray !important;
}
.main-div .font16 {
  font-size: 14px !important;
  font-family: "Raleway";
  color: #212427 !important;
}
.main-div .table-wrapper .table-inner {
  border-radius: 5px;
  max-height: 300px;
  height: 100%;
  position: relative;
  overflow: hidden;
  min-height: 300px;
  border: 1px solid lightgray;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-div .table-wrapper .table-inner img.img-display {
  max-width: 100%;
  max-height: 250px;
  object-fit: contain;
}
.main-div .table-wrapper .table-inner video.video-display {
  width: 100%;
  height: 100%;
}
.main-div .table-wrapper p {
  color: #212427 !important;
  text-align: left !important;
  padding: 10px;
  line-height: 20px;
}
.main-div button.close {
  position: absolute;
  top: -2px;
  right: 6px;
  z-index: 10;
}
.main-div .btn-primary {
  background-color: #5ea1d8;
  border: none;
}
.main-div .flowbycat {
  background-color: transparent;
}
.main-div .hide_file {
  position: absolute;
  z-index: 1000;
  opacity: 0;
  cursor: pointer;
  right: 0;
  top: 0;
  height: 100%;
  font-size: 24px;
  width: 100%;
}
@media only screen and (max-width: 1024px) and (min-width: 768px) {
  .main-div .main-div {
    min-height: 92vh;
  }
  .main-div .main-content {
    width: 75%;
  }
}

@media only screen and (max-width: 767px) and (min-width: 320px) {
  .main-div {
    background: #fff !important;
  }
  .main-div .main-content {
    width: calc(100% - 30px) !important;
    padding: 5px 5px 20px !important;
  }
}
@media (max-width: 460px) {
  .main-div .table-wrapper .table-inner {
    max-height: 150px;
    min-height: 150px;
  }
  .main-div .table-wrapper .table-inner img.img-display {
    max-height: 100px;
  }
  .main-div .table-wrapper .table-inner .video-display {
    max-height: 100px;
  }
}
.card {
  height: 100px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  width: 30%;
}

.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}

.container {
  padding: 2px 16px;
}

/* new design starta here*/
.createBund .card {
  width: calc(50% - 30px);
  box-shadow: none;
  margin: 40px auto 0px auto;
  height: auto !important;
}
.createBund .card .container {
  padding: 5px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.createBund .card h4 {
  margin: 0px !important;
}
.createBund .card p {
  margin: 0px !important;
}
.createBund .card .mat-icon {
  width: auto;
  color: #212427;
  text-shadow: 0px 2px 2px rgba(186, 183, 183, 0.4);
  font-size: 35px !important;
  height: auto;
}
.createBund form + .row {
  text-align: center;
  width: 100%;
  margin: 0px !important;
  display: flex;
  align-items: center;
  justify-content: end;
}
.createBund .item {
  padding: 5px;
  width: 31% !important;
  margin-right: 0px !important;
  margin-left: 0px !important;
  border: 1px solid #ddd !important;
  margin: 5px !important;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: -2px 2px 7px hsla(0, 6%, 77%, 0.5);
}
.createBund .item .example-margin {
  position: absolute;
  top: -4px;
  right: -9px;
  color: black;
  font-size: 24px !important;
}
.createBund .item p {
  text-align: left;
}
.createBund .item img {
  border: 1px solid #ddd;
  width: calc(100% - 10px) !important;
  height: 150px !important;
  border-radius: 0 !important;
  margin: 5px !important;
  object-fit: cover;
}
.createBund .item .with-icon {
  display: flex;
}
.createBund .item .with-icon img {
  width: 30px !important;
  height: 30px !important;
  border-radius: 20px !important;
}
.createBund .mat-checkbox {
  position: absolute;
  top: 5px;
  right: 5px;
}
.createBund .mat-checkbox .mat-checkbox-frame {
  border-color: rgb(94, 161, 216) !important;
}

@media (max-width: 768px) {
  .createBund .main-div .table-wrapper .table-inner {
    min-height: 210px !important;
  }
}
@media (max-width: 460px) {
  .createBund form + .row {
    width: 100% !important;
    display: flex;
    justify-content: space-between;
  }
  .createBund .item {
    width: 47% !important;
    margin: 5px !important;
  }
}
@media only screen and (min-width: 461px) and (max-width: 1024px) {
  .createBund form + .row {
    width: 100% !important;
    display: flex;
    justify-content: space-evenly;
  }
  .createBund .item {
    width: 31% !important;
    margin: 5px !important;
  }
}
.bundleIcon {
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 10;
  width: 25px;
  height: 25px;
}
.bundleIcon img {
  width: 100% !important;
  height: auto !important;
  object-fit: contain;
  border: none;
}

.upload-tab-item {
  display: flex;
  padding: 0px;
  margin-top: 10px;
  flex-wrap: wrap;
  align-items: center;
}
.upload-tab-item .inputfield {
  order: 1;
}
.upload-tab-item .file-details {
  order: 4;
  display: block;
  width: 100%;
  text-align: left;
  padding: 0px 10px;
}
.upload-tab-item .item-field {
  order: 2;
  height: 56px;
}
.upload-tab-item .addbtn {
  order: 3;
  height: 56px;
}
.upload-tab-item .example-list {
  margin-bottom: 20px;
}
.upload-tab-item .example-list .example-box {
  border: 1px solid gray;
  display: flex;
  align-items: center;
}
.upload-tab-item .example-list .example-box span {
  flex: 2;
  display: block;
  height: 100%;
  text-align: left;
  padding: 0px 10px 0px 0px;
}
.upload-tab-item .example-list .example-box span:last-child {
  flex: 1;
  text-align: center;
}
.upload-tab-item .example-list .example-box span:nth-child(2) {
  border-left: 1px solid gray;
  border-right: 1px solid gray;
}
.upload-tab-item .example-list .example-box + .example-box {
  border-top: 0px;
}

.tab-design-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 10px;
}
.tab-design-wrapper .tab-design-item:last-child {
  display: block;
  position: relative;
  order: 4;
}
.tab-design-wrapper .addbtn {
  height: 56px;
}

.example-list {
  margin-bottom: 20px;
}
.example-list .example-box {
  border: 1px solid gray;
  display: flex;
  align-items: center;
}
.example-list .example-box span {
  border-right: 1px solid gray;
  display: flex;
  text-align: left;
  padding: 5px 10px 5px 5px;
  align-self: stretch;
  align-items: center;
  word-break: break-all;
}
.example-list .example-box span:first-child {
  width: 20%;
}
.example-list .example-box span:nth-child(2) {
  width: 70%;
  word-break: break-all;
}
.example-list .example-box span:nth-child(3) {
  width: 50px;
  justify-content: center;
}
.example-list .example-box span:last-child {
  width: 50px;
  text-align: center;
  border-right: 0px;
  justify-content: center;
}
.example-list .example-box + .example-box {
  border-top: 0px;
}

.file-details {
  order: 5;
  margin-bottom: 10px;
  margin-left: 14px;
}

.doclengthplacement {
  padding: 0px 20px 0px 40px;
  width: 75%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  /* Make the counter occupy its own row in flex wrappers */
  flex: 0 0 100%;
  order: 2;
  margin: 4px 0 8px 0;
}

.img-div-left.small-spinner {
  position: absolute !important;
  width: 100px !important;
  height: 100px !important;
  top: 100px !important;
}
.img-div-left.small-spinner img {
  width: 100px !important;
  height: 100px !important;
  top: unset !important;
}

.clickable-text {
  color: #007bff;
  /* Link color */
  cursor: pointer;
  /* Pointer cursor on hover */
  text-decoration: underline;
  /* Underline text */
  display: flex;
  align-items: center;
  justify-content: center;
}

.clickable-text:hover {
  color: #0056b3;
  /* Darker shade on hover */
}

/* Ensure AI action links wrap nicely and don't overlap */
.commonlintbtn-parent {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  flex-wrap: wrap;
}

.example-chip-list {
  width: 100%;
}

.cam-icon {
  display: flex;
  flex-direction: row;
  align-items: center;
}

/* Mobile refinements for tighter alignment and smaller UI on small screens */
@media (max-width: 460px) {
  h3 {
    font-size: 16px !important;
  }
  .font16 {
    font-size: 12px !important;
  }
  .clickable-text {
    font-size: 12px;
    gap: 4px;
  }
  .clickable-text .material-icons {
    font-size: 18px !important;
    line-height: 1;
  }
  .fileExplorer.btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    font-size: 12px;
  }
  .fileExplorer.btn mat-icon {
    font-size: 18px !important;
  }
  .label-button {
    flex-wrap: wrap;
  }
  .label-button label {
    font-size: 12px !important;
  }
  .label-button mat-slide-toggle {
    margin-left: 10px !important;
    transform: scale(0.9);
  }
  .example-list .example-box span {
    font-size: 12px;
  }
  .doclengthplacement {
    padding: 0px 10px;
    width: 100%;
    display: block;
    text-align: right;
    margin: 6px 0 10px 0;
  }
  /* Break long filenames/URLs and prevent row overlaps */
  .file-details {
    word-break: break-word;
    white-space: normal;
  }
  /* Stack list rows when narrow to avoid icon/text clashes */
  .example-list .example-box {
    flex-direction: column;
    align-items: stretch;
  }
  .example-list .example-box span {
    width: 100% !important;
    border-right: 0;
  }
  /* Upload hint position should not overlap the icon */
  .fileExplorer mat-hint {
    position: static !important;
    left: auto !important;
    top: auto !important;
    display: block;
    text-align: center;
    margin-top: 2px;
  }
  /* Quill toolbar buttons wrap instead of overlapping */
  .ql-toolbar .ql-formats {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 2px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/cover-page/cover-page.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AACF;AACE;EACE,WAAA;AACJ;;AAGA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,8BAAA;AAAF;AAEE;EACE,kCAAA;EACA,gBAAA;EACA,6BAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,iDAAA;EACA,kBAAA;AAAJ;AAIE;EACE,gCAAA;AAFJ;AAKE;EACE,0BAAA;EACA,sBAAA;EACA,yBAAA;AAHJ;AAOI;EACE,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AALN;AAOM;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;AALR;AAQM;EACE,WAAA;EACA,YAAA;AANR;AAUI;EACE,yBAAA;EACA,2BAAA;EACA,aAAA;EACA,iBAAA;AARN;AAYE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;AAVJ;AAaE;EACE,yBAAA;EACA,YAAA;AAXJ;AAcE;EACE,6BAAA;AAZJ;AAeE;EACE,kBAAA;EACA,aAAA;EACA,UAAA;EACA,eAAA;EACA,QAAA;EACA,MAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;AAbJ;AAgBE;EACE;IACE,gBAAA;EAdJ;EAiBE;IACE,UAAA;EAfJ;AACF;;AAmBA;EACE;IACE,2BAAA;EAhBF;EAkBE;IACE,mCAAA;IACA,gCAAA;EAhBJ;AACF;AAoBA;EAEI;IACE,iBAAA;IACA,iBAAA;EAnBJ;EAqBI;IACE,iBAAA;EAnBN;EAsBI;IACE,iBAAA;EApBN;AACF;AAyBA;EACE,aAAA;EACA,0CAAA;EACA,gBAAA;EACA,UAAA;AAvBF;;AA0BA;EACE,2CAAA;AAvBF;;AA0BA;EACE,iBAAA;AAvBF;;AA0BA,0BAAA;AAEE;EACE,uBAAA;EACA,gBAAA;EACA,0BAAA;EACA,uBAAA;AAxBJ;AA0BI;EACE,iBAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AAzBN;AA4BI;EACE,sBAAA;AA1BN;AA6BI;EACE,sBAAA;AA3BN;AA8BI;EACE,WAAA;EACA,cAAA;EACA,iDAAA;EACA,0BAAA;EACA,YAAA;AA5BN;AAgCE;EACE,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;AA9BJ;AAiCE;EACE,YAAA;EACA,qBAAA;EACA,4BAAA;EACA,2BAAA;EAEA,iCAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,8CAAA;AAhCJ;AAkCI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,0BAAA;AAhCN;AAmCI;EACE,gBAAA;AAjCN;AAoCI;EACE,sBAAA;EACA,mCAAA;EACA,wBAAA;EACA,2BAAA;EACA,sBAAA;EACA,iBAAA;AAlCN;AAqCI;EACE,aAAA;AAnCN;AAqCM;EACE,sBAAA;EACA,uBAAA;EACA,8BAAA;AAnCR;AAwCE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;AAtCJ;AAwCI;EACE,0CAAA;AAtCN;;AA2CA;EAGM;IACE,4BAAA;EA1CN;AACF;AA+CA;EAEI;IACE,sBAAA;IACA,aAAA;IACA,8BAAA;EA9CJ;EAiDE;IACE,qBAAA;IACA,sBAAA;EA/CJ;AACF;AAmDA;EAEI;IACE,sBAAA;IACA,aAAA;IACA,6BAAA;EAlDJ;EAqDE;IACE,qBAAA;IACA,sBAAA;EAnDJ;AACF;AAuDA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;AArDF;AAuDE;EACE,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AArDJ;;AAyDA;EACE,aAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAtDF;AAwDE;EACE,QAAA;AAtDJ;AAyDE;EACE,QAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;AAvDJ;AA0DE;EACE,QAAA;EACA,YAAA;AAxDJ;AA2DE;EACE,QAAA;EACA,YAAA;AAzDJ;AA4DE;EAEE,mBAAA;AA3DJ;AA6DI;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;AA3DN;AA6DM;EACE,OAAA;EAEA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;AA5DR;AA8DQ;EACE,OAAA;EACA,kBAAA;AA5DV;AA+DQ;EACE,2BAAA;EACA,4BAAA;AA7DV;AAiEM;EACE,eAAA;AA/DR;;AAqEA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AAlEF;AAsEI;EACE,cAAA;EACA,kBAAA;EACA,QAAA;AApEN;AAwEE;EACE,YAAA;AAtEJ;;AA0EA;EAEE,mBAAA;AAxEF;AA0EE;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;AAxEJ;AA0EI;EAEE,4BAAA;EACA,aAAA;EAEA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;AA1EN;AA4EM;EACE,UAAA;AA1ER;AA6EM;EACE,UAAA;EACA,qBAAA;AA3ER;AA8EM;EACE,WAAA;EACA,uBAAA;AA5ER;AA+EM;EACE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;AA7ER;AAiFI;EACE,eAAA;AA/EN;;AAoFA;EACE,QAAA;EACA,mBAAA;EACA,iBAAA;AAjFF;;AAoFA;EACE,0BAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,yDAAA;EACA,cAAA;EACA,QAAA;EACA,mBAAA;AAjFF;;AAoFA;EAGE,6BAAA;EACA,uBAAA;EACA,wBAAA;EAEA,qBAAA;AApFF;AAsFE;EACE,uBAAA;EACA,wBAAA;EACA,qBAAA;AApFJ;;AAwFA;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,4BAAA;EACA,0BAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AArFF;;AAwFA;EACE,cAAA;EACA,0BAAA;AArFF;;AAwFA,yDAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,QAAA;EACA,eAAA;AArFF;;AAwFA;EACE,WAAA;AArFF;;AAwFA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AArFF;;AAwFA,6EAAA;AACA;EACE;IACE,0BAAA;EArFF;EAwFA;IACE,0BAAA;EAtFF;EAyFA;IACE,eAAA;IACA,QAAA;EAvFF;EAyFE;IACE,0BAAA;IACA,cAAA;EAvFJ;EA2FA;IACE,oBAAA;IACA,mBAAA;IACA,QAAA;IACA,iBAAA;IACA,eAAA;EAzFF;EA2FE;IACE,0BAAA;EAzFJ;EA6FA;IACE,eAAA;EA3FF;EA6FE;IACE,0BAAA;EA3FJ;EA8FE;IACE,4BAAA;IACA,qBAAA;EA5FJ;EAgGA;IACE,eAAA;EA9FF;EAiGA;IACE,iBAAA;IACA,WAAA;IACA,cAAA;IACA,iBAAA;IACA,oBAAA;EA/FF;EAkGA,uDAAA;EACA;IACE,sBAAA;IACA,mBAAA;EAhGF;EAmGA,2DAAA;EACA;IACE,sBAAA;IACA,oBAAA;EAjGF;EAmGE;IACE,sBAAA;IACA,eAAA;EAjGJ;EAqGA,qDAAA;EACA;IACE,2BAAA;IACA,qBAAA;IACA,oBAAA;IACA,cAAA;IACA,kBAAA;IACA,eAAA;EAnGF;EAsGA,sDAAA;EACA;IACE,oBAAA;IACA,eAAA;IACA,QAAA;EApGF;AACF","sourcesContent":[".mat-badge-content {\n  background: #5ea1d8;\n}\n\ninput {\n  outline: none !important;\n}\n\nlabel {\n  color: #212427 !important;\n}\n\n.label-button {\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n\n  label {\n    margin: 0px;\n  }\n}\n\n.main-div {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 89vh;\n  background: #efeeee !important;\n\n  .main-content {\n    border-radius: 10px 10px 10px 10px;\n    background: #fff;\n    padding: 20px 20px !important;\n    width: 90%;\n    max-width: 600px;\n    max-height: auto;\n    width: 100%;\n    position: relative;\n    padding: 0px;\n    border: 1px solid #ddd;\n    box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n    text-align: center;\n    // border: 0.5px solid lightgrey;\n  }\n\n  .mat-form-field-appearance-legacy .mat-form-field-underline {\n    background: lightgray !important;\n  }\n\n  .font16 {\n    font-size: 14px !important;\n    font-family: \"Raleway\";\n    color: #212427 !important;\n  }\n\n  .table-wrapper {\n    .table-inner {\n      border-radius: 5px;\n      max-height: 300px;\n      height: 100%;\n      position: relative;\n      overflow: hidden;\n      min-height: 300px;\n      border: 1px solid lightgray;\n      background: #fff;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      img.img-display {\n        max-width: 100%;\n        max-height: 250px;\n        object-fit: contain;\n      }\n\n      video.video-display {\n        width: 100%;\n        height: 100%;\n      }\n    }\n\n    p {\n      color: #212427 !important;\n      text-align: left !important;\n      padding: 10px;\n      line-height: 20px;\n    }\n  }\n\n  button.close {\n    position: absolute;\n    top: -2px;\n    right: 6px;\n    z-index: 10;\n  }\n\n  .btn-primary {\n    background-color: #5ea1d8;\n    border: none;\n  }\n\n  .flowbycat {\n    background-color: transparent;\n  }\n\n  .hide_file {\n    position: absolute;\n    z-index: 1000;\n    opacity: 0;\n    cursor: pointer;\n    right: 0;\n    top: 0;\n    height: 100%;\n    font-size: 24px;\n    width: 100%;\n  }\n\n  @media only screen and (max-width: 1024px) and (min-width: 768px) {\n    .main-div {\n      min-height: 92vh;\n    }\n\n    .main-content {\n      width: 75%;\n    }\n  }\n}\n\n@media only screen and (max-width: 767px) and (min-width: 320px) {\n  .main-div {\n    background: #fff !important;\n\n    .main-content {\n      width: calc(100% - 30px) !important;\n      padding: 5px 5px 20px !important;\n    }\n  }\n}\n\n@media (max-width: 460px) {\n  .main-div {\n    .table-wrapper .table-inner {\n      max-height: 150px;\n      min-height: 150px;\n\n      img.img-display {\n        max-height: 100px;\n      }\n\n      .video-display {\n        max-height: 100px;\n      }\n    }\n  }\n}\n\n.card {\n  height: 100px;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n  transition: 0.3s;\n  width: 30%;\n}\n\n.card:hover {\n  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);\n}\n\n.container {\n  padding: 2px 16px;\n}\n\n/* new design starta here*/\n.createBund {\n  .card {\n    width: calc(50% - 30px);\n    box-shadow: none;\n    margin: 40px auto 0px auto;\n    height: auto !important;\n\n    .container {\n      padding: 5px 16px;\n\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex-direction: column;\n    }\n\n    h4 {\n      margin: 0px !important;\n    }\n\n    p {\n      margin: 0px !important;\n    }\n\n    .mat-icon {\n      width: auto;\n      color: #212427;\n      text-shadow: 0px 2px 2px rgb(186 183 183 / 40%);\n      font-size: 35px !important;\n      height: auto;\n    }\n  }\n\n  form+.row {\n    text-align: center;\n    width: 100%;\n    margin: 0px !important;\n    display: flex;\n    align-items: center;\n    justify-content: end;\n  }\n\n  .item {\n    padding: 5px;\n    width: 31% !important;\n    margin-right: 0px !important;\n    margin-left: 0px !important;\n\n    border: 1px solid #ddd !important;\n    margin: 5px !important;\n    overflow: hidden;\n    background: #fff;\n    position: relative;\n    box-shadow: -2px 2px 7px hsl(0deg 6% 77% / 50%);\n\n    .example-margin {\n      position: absolute;\n      top: -4px;\n      right: -9px;\n      color: black;\n      font-size: 24px !important;\n    }\n\n    p {\n      text-align: left;\n    }\n\n    img {\n      border: 1px solid #ddd;\n      width: calc(100% - 10px) !important;\n      height: 150px !important;\n      border-radius: 0 !important;\n      margin: 5px !important;\n      object-fit: cover;\n    }\n\n    .with-icon {\n      display: flex;\n\n      img {\n        width: 30px !important;\n        height: 30px !important;\n        border-radius: 20px !important;\n      }\n    }\n  }\n\n  .mat-checkbox {\n    position: absolute;\n    top: 5px;\n    right: 5px;\n\n    .mat-checkbox-frame {\n      border-color: rgb(94, 161, 216) !important;\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .createBund {\n    .main-div {\n      .table-wrapper .table-inner {\n        min-height: 210px !important;\n      }\n    }\n  }\n}\n\n@media (max-width: 460px) {\n  .createBund {\n    form+.row {\n      width: 100% !important;\n      display: flex;\n      justify-content: space-between;\n    }\n\n    .item {\n      width: 47% !important;\n      margin: 5px !important;\n    }\n  }\n}\n\n@media only screen and (min-width: 461px) and (max-width: 1024px) {\n  .createBund {\n    form+.row {\n      width: 100% !important;\n      display: flex;\n      justify-content: space-evenly;\n    }\n\n    .item {\n      width: 31% !important;\n      margin: 5px !important;\n    }\n  }\n}\n\n.bundleIcon {\n  position: absolute;\n  bottom: 10px;\n  right: 10px;\n  z-index: 10;\n  width: 25px;\n  height: 25px;\n\n  img {\n    width: 100% !important;\n    height: auto !important;\n    object-fit: contain;\n    border: none;\n  }\n}\n\n.upload-tab-item {\n  display: flex;\n  padding: 0px;\n  margin-top: 10px;\n  flex-wrap: wrap;\n  align-items: center;\n\n  .inputfield {\n    order: 1;\n  }\n\n  .file-details {\n    order: 4;\n    display: block;\n    width: 100%;\n    text-align: left;\n    padding: 0px 10px;\n  }\n\n  .item-field {\n    order: 2;\n    height: 56px;\n  }\n\n  .addbtn {\n    order: 3;\n    height: 56px;\n  }\n\n  .example-list {\n    // border:1px solid gray;\n    margin-bottom: 20px;\n\n    .example-box {\n      border: 1px solid gray;\n      display: flex;\n      align-items: center;\n\n      span {\n        flex: 2;\n        // border-right: 1px solid gray;\n        display: block;\n        height: 100%;\n        text-align: left;\n        padding: 0px 10px 0px 0px;\n\n        &:last-child {\n          flex: 1;\n          text-align: center;\n        }\n\n        &:nth-child(2) {\n          border-left: 1px solid gray;\n          border-right: 1px solid gray;\n        }\n      }\n\n      &+.example-box {\n        border-top: 0px;\n      }\n    }\n  }\n}\n\n.tab-design-wrapper {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  margin-top: 10px;\n\n  // display: none !important;\n  .tab-design-item {\n    &:last-child {\n      display: block;\n      position: relative;\n      order: 4;\n    }\n  }\n\n  .addbtn {\n    height: 56px;\n  }\n}\n\n.example-list {\n  // border:1px solid gray;\n  margin-bottom: 20px;\n\n  .example-box {\n    border: 1px solid gray;\n    display: flex;\n    align-items: center;\n\n    span {\n      // flex: 2;\n      border-right: 1px solid gray;\n      display: flex;\n      // height: 100%;\n      text-align: left;\n      padding: 5px 10px 5px 5px;\n      align-self: stretch;\n      align-items: center;\n      word-break: break-all;\n\n      &:first-child {\n        width: 20%;\n      }\n\n      &:nth-child(2) {\n        width: 70%;\n        word-break: break-all;\n      }\n\n      &:nth-child(3) {\n        width: 50px;\n        justify-content: center;\n      }\n\n      &:last-child {\n        width: 50px;\n        text-align: center;\n        border-right: 0px;\n        justify-content: center;\n      }\n    }\n\n    &+.example-box {\n      border-top: 0px;\n    }\n  }\n}\n\n.file-details {\n  order: 5;\n  margin-bottom: 10px;\n  margin-left: 14px;\n}\n\n.doclengthplacement {\n  padding: 0px 20px 0px 40px;\n  width: 75%;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  /* Make the counter occupy its own row in flex wrappers */\n  flex: 0 0 100%;\n  order: 2;\n  margin: 4px 0 8px 0;\n}\n\n.img-div-left.small-spinner {\n\n\n  position: absolute !important;\n  width: 100px !important;\n  height: 100px !important;\n\n  top: 100px !important;\n\n  img {\n    width: 100px !important;\n    height: 100px !important;\n    top: unset !important;\n  }\n}\n\n.clickable-text {\n  color: #007bff;\n  /* Link color */\n  cursor: pointer;\n  /* Pointer cursor on hover */\n  text-decoration: underline;\n  /* Underline text */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.clickable-text:hover {\n  color: #0056b3;\n  /* Darker shade on hover */\n}\n\n/* Ensure AI action links wrap nicely and don't overlap */\n.commonlintbtn-parent {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.example-chip-list {\n  width: 100%;\n}\n\n.cam-icon {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n/* Mobile refinements for tighter alignment and smaller UI on small screens */\n@media (max-width: 460px) {\n  h3 {\n    font-size: 16px !important;\n  }\n\n  .font16 {\n    font-size: 12px !important;\n  }\n\n  .clickable-text {\n    font-size: 12px;\n    gap: 4px;\n\n    .material-icons {\n      font-size: 18px !important;\n      line-height: 1;\n    }\n  }\n\n  .fileExplorer.btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 6px 10px;\n    font-size: 12px;\n\n    mat-icon {\n      font-size: 18px !important;\n    }\n  }\n\n  .label-button {\n    flex-wrap: wrap;\n\n    label {\n      font-size: 12px !important;\n    }\n\n    mat-slide-toggle {\n      margin-left: 10px !important;\n      transform: scale(0.9);\n    }\n  }\n\n  .example-list .example-box span {\n    font-size: 12px;\n  }\n\n  .doclengthplacement {\n    padding: 0px 10px;\n    width: 100%;\n    display: block;\n    text-align: right;\n    margin: 6px 0 10px 0;\n  }\n\n  /* Break long filenames/URLs and prevent row overlaps */\n  .file-details {\n    word-break: break-word;\n    white-space: normal;\n  }\n\n  /* Stack list rows when narrow to avoid icon/text clashes */\n  .example-list .example-box {\n    flex-direction: column;\n    align-items: stretch;\n\n    span {\n      width: 100% !important;\n      border-right: 0;\n    }\n  }\n\n  /* Upload hint position should not overlap the icon */\n  .fileExplorer mat-hint {\n    position: static !important;\n    left: auto !important;\n    top: auto !important;\n    display: block;\n    text-align: center;\n    margin-top: 2px;\n  }\n\n  /* Quill toolbar buttons wrap instead of overlapping */\n  .ql-toolbar .ql-formats {\n    display: inline-flex;\n    flex-wrap: wrap;\n    gap: 2px;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
